import { useEffect } from "react";
import { DECK } from "@/components/slides/Deck";

export default function Slides() {
  useEffect(() => {
    document.title = "Apresentação · Pedro Clube Show";
  }, []);
  return (
    <main className="deck" data-testid="slides-deck">
      {DECK.map((S, i) => (
        <S key={i} n={i + 1} total={DECK.length} />
      ))}
    </main>
  );
}
